import { fetchFactory } from 'isotope-client'

export const getSalesRepresentatives = (query) => fetchFactory(`/search/sales-representatives?query=${query}`, {}, "/api")
export const getContracts = (query) => fetchFactory(`/search/contracts?query=${query}`, {}, "/api")